export const Color = Object.freeze({
    happyPiglets: "#fbc9c4",
    camelia: "#e37867",
    peanut: "#754237",
    crownOfThorns: "#734136"
});
